import React from "react"

const  Testimonials = () => {
    return (
        <div className="">
            <h1 style={{margin:"18rem auto", color:"white"}}>Testimonials Coming Soon ...</h1>
        </div>
    )
}
export default Testimonials
